import { FormikContextType } from "formik";
import { TGetServiceHolderResponse } from "../../../../../../api/serviceHolder/apiGetServiceHolder";
import { TContactInfo, TServiceValuationForm } from "./types";
import moment from "moment";
import {
  SERVICE_HOLDER_HOME_FEATURE_ADAPTED_BATHROOM,
  SERVICE_HOLDER_HOME_FEATURE_ARTICULATED_BED,
  SERVICE_HOLDER_HOME_FEATURE_CAMERAS,
  SERVICE_HOLDER_HOME_FEATURE_CLEAN_SERVICE,
  SERVICE_HOLDER_HOME_FEATURE_CRANE,
  SERVICE_HOLDER_HOME_FEATURE_ELEVATOR,
  SERVICE_HOLDER_HOME_FEATURE_PETS,
  SERVICE_HOLDER_HOME_FEATURE_TELE_ASSISTANCE,
} from "../../../../../../util/defaults/serviceHolder";
import uuidv4 from "uuid/v4";
import { TGetServicesCollectionItem } from "../../../../../../api/service/service.types";

const selectServiceHolder = (
  formikContext: FormikContextType<TServiceValuationForm>,
  serviceHolder: TGetServiceHolderResponse,
  service: TGetServicesCollectionItem,
  regionOptions: { value: string; label: string }[],
  areaOptions: { value: string; label: string }[],
  familiarUnitOptions: { value: string; label: string }[],
  pathologyOptions: { value: string; label: string }[],
  speechOptions: { value: string; label: string }[],
  mobilityOptions: { value: string; label: string }[],
  emotionalStatusOptions: { value: string; label: string }[],
  careAdaptationOptions: { value: string; label: string }[],
  sleepQualityOptions: { value: string; label: string }[],
  toiletLevelOptions: { value: string; label: string }[],
  serviceHolderUserStatusOptions: { value: string; label: string }[],
  dependencyOptions: { value: string; label: string }[]
) => {
  const newRelationships: TContactInfo[] = [];
  serviceHolder.relatedContacts?.forEach((relation) => {
    if (relation.id && relation.Contacto && relation.Contacto.id) {
      newRelationships.push({
        id: relation.id,
        contact_id: relation.Contacto.id,
        op: "existing_relation",
        contact_crm_id: relation.Contacto.zohoId,
        Parentesco: "",
        Email: relation.Contacto?.Email ?? "",
        First_Name: relation.Contacto?.First_Name ?? "",
        Last_Name: relation.Contacto?.Last_Name ?? "",
        Phone: relation.Contacto?.Phone ?? "",
      });
    }
  });

  if (service.customer) {
    const existingContact = newRelationships.find(
      (relationship) => relationship.contact_id === service.customer?.id
    );
    if (existingContact) {
    } else {
      newRelationships.push({
        id: uuidv4(),
        Email: service.customer.Email ?? "",
        First_Name: service.customer.First_Name ?? "",
        Last_Name: service.customer.Last_Name ?? "",
        Phone: service.customer.Phone ?? "",
        contact_id: service.customer.id,
        Parentesco: service.customer.Parentesco ?? "",
        op: "new_relation_existing_contact",
      });
    }
  }

  const data = {
    ...formikContext.values,
    service_holder_op: "existing",
    service_holder_id: serviceHolder.id,
    Usuarios_a_cuidar: serviceHolder.Usuarios_a_cuidar === 2 ? "2" : "1",
    Unidad_de_convivencia: serviceHolder.Unidad_de_convivencia,
    Direccion: serviceHolder.Direccion,
    Direccion_2: serviceHolder.Direccion_2,
    Ciudad: serviceHolder.Ciudad
      ? {
          value: serviceHolder.Ciudad,
          label: serviceHolder.Ciudad,
        }
      : null,
    Codigo_postal: serviceHolder.Codigo_postal,
    Region:
      regionOptions.find((region) => region.value === serviceHolder.Region) ??
      null,
    Area: areaOptions.find((area) => area.value === serviceHolder.Area) ?? null,
    Latitud: serviceHolder.Latitud
      ? parseFloat(serviceHolder.Latitud)
      : undefined,
    Longitud: serviceHolder.Longitud
      ? parseFloat(serviceHolder.Longitud)
      : undefined,
    formatted_address: undefined,

    Estado_U1:
      serviceHolderUserStatusOptions.find(
        (status) => status.value === serviceHolder.Estado_U1
      ) ?? null,
    Nombre_U1: serviceHolder.Nombre_U1,
    Primer_apellido_U1: serviceHolder.Primer_apellido_U1,
    Segundo_apellido_U1: serviceHolder.Segundo_apellido_U1,
    Fecha_de_nacimiento_U1: moment(
      serviceHolder.Fecha_de_nacimiento_U1
    ).isValid()
      ? moment(serviceHolder.Fecha_de_nacimiento_U1).toDate()
      : null,
    DNI_U1: serviceHolder.DNI_U1,
    Grado_Ley_de_dependencia_U1:
      dependencyOptions.find(
        (option) => option.value === serviceHolder.Grado_Ley_de_dependencia_U1
      ) ?? null,

    Patologias_U1: pathologyOptions.filter(
      (pathology) =>
        !!serviceHolder.Patologias_U1?.find((sp) => {
          return sp === pathology.value;
        })
    ),
    Comentarios_patologias_U1: serviceHolder.Comentarios_patologias_U1 ?? "",
    Medicacion_U1: serviceHolder.Medicacion_U1 ?? "",
    Dieta: serviceHolder.Dieta ?? "",
    Habla_expresion_U1: serviceHolder.Habla_expresion_U1 ?? "",
    Peso_U1: serviceHolder.Peso_U1 + "",
    Altura_U1: serviceHolder.Altura_U1 + "",
    Movilidad_U1: mobilityOptions.filter(
      (mobilityOption) =>
        !!serviceHolder.Movilidad_U1?.find((mo) => {
          return mo === mobilityOption.value;
        })
    ),
    Comentarios_movilidad_U1: serviceHolder.Comentarios_movilidad_U1 ?? "",

    Estado_emocional_y_caracter_U1: emotionalStatusOptions.filter(
      (emotionalStatus) =>
        !!serviceHolder.Estado_emocional_y_caracter_U1?.find((s) => {
          return s === emotionalStatus.value;
        })
    ),
    Adaptaci_n_de_cuidados_U1: serviceHolder.Adaptaci_n_de_cuidados_U1 ?? "",
    Comentarios_estado_emocional_y_caracter_U1:
      serviceHolder.Comentarios_estado_emocional_y_caracter_U1 ?? "",
    Actividades_y_aficiones_U1: serviceHolder.Actividades_y_aficiones_U1 ?? "",
    Calidad_del_sue_o_U1:
      sleepQualityOptions.find(
        (option) => option.value === serviceHolder.Calidad_del_sue_o_U1
      ) ?? null,
    Aseo_U1: toiletLevelOptions.filter(
      (toiletOption) =>
        !!serviceHolder.Aseo_U1?.find((t) => t === toiletOption.value)
    ),
    Indicaciones_del_sueno_U1: serviceHolder.Indicaciones_del_sueno_U1 ?? "",
    Indicaciones_del_aseo_U1: serviceHolder.Indicaciones_del_aseo_U1 ?? "",

    Estado_U2:
      serviceHolderUserStatusOptions.find(
        (status) => status.value === serviceHolder.Estado_U2
      ) ?? null,
    Nombre_U2: serviceHolder.Nombre_U2 ?? "",
    Primer_apellido_U2: serviceHolder.Primer_apellido_U2 ?? "",
    Segundo_apellido_U2: serviceHolder.Segundo_apellido_U2 ?? "",
    Fecha_de_nacimiento_U2: moment(
      serviceHolder.Fecha_de_nacimiento_U2
    ).isValid()
      ? moment(serviceHolder.Fecha_de_nacimiento_U2).toDate()
      : null,
    DNI_U2: serviceHolder.DNI_U2 ?? "",
    Grado_Ley_de_dependencia_U2:
      dependencyOptions.find(
        (option) => option.value === serviceHolder.Grado_Ley_de_dependencia_U2
      ) ?? null,

    Patologias_U2: pathologyOptions.filter(
      (pathology) =>
        !!serviceHolder.Patologias_U2?.find((sp) => {
          return sp === pathology.value;
        })
    ),
    Comentarios_patologias_U2: serviceHolder.Comentarios_patologias_U2 ?? "",
    Medicacion_U2: serviceHolder.Medicacion_U2 ?? "",
    Dieta_U2: serviceHolder.Dieta_U2 ?? "",
    Habla_expresion_U2: serviceHolder.Habla_expresion_U2 ?? "",
    Peso_U2: serviceHolder.Peso_U2 + "",
    Altura_U2: serviceHolder.Altura_U2 + "",
    Movilidad_U2: mobilityOptions.filter(
      (mobilityOption) =>
        !!serviceHolder.Movilidad_U2?.find((mo) => {
          return mo === mobilityOption.value;
        })
    ),
    Comentarios_movilidad_U2: serviceHolder.Comentarios_movilidad_U2 ?? "",

    Estado_emocional_y_caracter_U2: emotionalStatusOptions.filter(
      (emotionalStatus) =>
        !!serviceHolder.Estado_emocional_y_caracter_U2?.find((s) => {
          return s === emotionalStatus.value;
        })
    ),
    Adaptaci_n_de_cuidados_U2: serviceHolder.Adaptaci_n_de_cuidados_U2 ?? "",
    Comentarios_estado_emocional_y_caracter_U2:
      serviceHolder.Comentarios_estado_emocional_y_caracter_U2 ?? "",
    Actividades_y_aficiones_U2: serviceHolder.Actividades_y_aficiones_U2 ?? "",
    Calidad_del_sue_o_U2:
      sleepQualityOptions.find(
        (option) => option.value === serviceHolder.Calidad_del_sue_o_U2
      ) ?? null,
    Aseo_U2: toiletLevelOptions.filter(
      (toiletOption) =>
        !!serviceHolder.Aseo_U2?.find((t) => t === toiletOption.value)
    ),
    Indicaciones_del_sueno_U2: serviceHolder.Indicaciones_del_sueno_U2 ?? "",
    Indicaciones_del_aseo_U2: serviceHolder.Indicaciones_del_aseo_U2 ?? "",

    Tipo_de_vivienda: serviceHolder.Tipo_de_vivienda ?? "",
    home_elevator:
      serviceHolder.Caracteristicas_de_la_vivienda?.includes(
        SERVICE_HOLDER_HOME_FEATURE_ELEVATOR
      ) ?? false,
    home_adapted_bathroom:
      serviceHolder.Caracteristicas_de_la_vivienda?.includes(
        SERVICE_HOLDER_HOME_FEATURE_ADAPTED_BATHROOM
      ) ?? false,
    home_crane:
      serviceHolder.Caracteristicas_de_la_vivienda?.includes(
        SERVICE_HOLDER_HOME_FEATURE_CRANE
      ) ?? false,
    home_cameras:
      serviceHolder.Caracteristicas_de_la_vivienda?.includes(
        SERVICE_HOLDER_HOME_FEATURE_CAMERAS
      ) ?? false,
    home_articulated_bed:
      serviceHolder.Caracteristicas_de_la_vivienda?.includes(
        SERVICE_HOLDER_HOME_FEATURE_ARTICULATED_BED
      ) ?? false,
    home_pets:
      serviceHolder.Caracteristicas_de_la_vivienda?.includes(
        SERVICE_HOLDER_HOME_FEATURE_PETS
      ) ?? false,
    home_clean_service:
      serviceHolder.Caracteristicas_de_la_vivienda?.includes(
        SERVICE_HOLDER_HOME_FEATURE_CLEAN_SERVICE
      ) ?? false,
    home_tele_asistance:
      serviceHolder.Caracteristicas_de_la_vivienda?.includes(
        SERVICE_HOLDER_HOME_FEATURE_TELE_ASSISTANCE
      ) ?? false,
    Proveedor_de_Teleasistencia:
      serviceHolder.Proveedor_de_Teleasistencia ?? "",
    Comunicacion_con_transporte_publico:
      serviceHolder.Comunicacion_con_transporte_publico ?? "",

    Contactos: newRelationships,
  } as TServiceValuationForm;

  formikContext.setValues(data);
};

export { selectServiceHolder };
